import React, { useContext } from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import InputBase from '@material-ui/core/InputBase'
import { makeStyles } from '@material-ui/core/styles'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'

import SearchIcon from '@material-ui/icons/Search'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import HelpIcon from '@material-ui/icons/Help'
import Logo from '../../assets/images/logo.png'
import { Box, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, Typography } from '@material-ui/core'
import { UserContext } from '../../context api/UserContext'
import moment from 'moment'
import CustomAvatar from '../CustomAvatar'
import { useHistory } from 'react-router'
import { ROUTES } from '../../shared/constants'
import CustomDropdown from '../Header/CustomDropdown'
import CustomDrop from '../CustomDrop'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    // width:'calc(100vw - 235px)'
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 0.95,
    display: 'none',
    color: 'white',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    color: 'black',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'white',
    display: 'flex',

    marginLeft: 0,
    marginTop: '25px',
    width: '250px',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(1, 2),
    height: '100%',
    // position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'linear-gradient(89.81deg, #33499F 0%, #169AC4 86.91%, #05CFD3 100%)',
  },
  inputInput: {
    padding: theme.spacing(1.4, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(0)}px)`,

    // transition: theme.transitions.create('width'),
    width: '100%',
    // [theme.breakpoints.up('sm')]: {
    //   width: '12ch',
    //   '&:focus': {
    //     width: '20ch',
    //   },
    // },
  },
  appbar1: {
    background: 'linear-gradient(89.81deg, #33499F 0%, #169AC4 86.91%, #05CFD3 100%)',
    height: '110px',
    // width: 'calc(100vw - 235px) !important',
    // marginLeft:'calc(100vw - 235px)',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    // width:'calc(100vw - 235px) !important'
  },
  appbar2: {
    background: 'linear-gradient(89.81deg, #33499F 0%, #169AC4 86.91%, #05CFD3 100%)',
    height: '100px',
    width: 'calc(100vw - 75px) !important',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: 'absolute',
    left: '73px',
  },
  icon: {
    paddingLeft: '20px',
    marginTop: '25px',
  },
  heading: {
    fontFamily: 'Calibri !important',
    fontWeight: 'bold !important',
    fontSize: '22px !important',
    paddingTop: '25px !important',
  },
}))

export default function Header({ open, searchQuery, setSearchQuery, GridAttend ,setPage}) {
  const classes = useStyles()
  let w = window.innerWidth
  const user = useContext(UserContext)

  let headerWidth = open ? w - 260 : w - 73
  let marginHeader = open ? 233 : 74
  const [open1, setOpen1] = React.useState(false)
  const anchorRef = React.useRef(null)
  const history = useHistory()
  const handleToggle = () => {
    setOpen1((prevOpen) => !prevOpen)
  }
  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen1(false)
    }
  }

  const handleLogout = () => {
    localStorage.clear()
    history.push(ROUTES.HOME)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen1(false)
  }
  return (
    <div className={classes.root}>
      <AppBar position="static" color="inherit" className={open ? classes.appbar1 : classes.appbar2}>
        <Toolbar>
          <div className={classes.title} style={{ fontFamily: 'Calibri', fontWeight: '500', paddingTop: '20px' }}>
            <Typography style={{ fontSize: '22px', fontWeight: 600, fontFamily: 'Open Sans' }}>
              Welcome! {user && user.user.name}{' '}
            </Typography>
            <Typography style={{ fontSize: '14px', fontWeight: 600 }}> {user && user.user.position}</Typography>
            <Typography style={{ fontSize: '14px', fontWeight: 600 }}> {moment().format('Do MMMM YYYY')}</Typography>
          </div>

          {!GridAttend && setSearchQuery && (
            <div className={classes.search}>
              <div
                style={{
                  width: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#EFF3FE',
                  borderRadius: '5px',
                }}
              >
                <ArrowDropDownIcon />
              </div>
              <div>
                <InputBase
                  placeholder={`Search`}
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ 'aria-label': 'search' }}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className={classes.searchIcon}>
                <SearchIcon style={{ color: '#CCCCCC' }} />
              </div>
            </div>
          )}
          <div className={classes.icon}>
            <NotificationsNoneIcon style={{ color: 'white', cursor: 'pointer' }} />
          </div>
          {user && user.user.userType === 'COMPANYADMIN' && (
            <div className={classes.icon}>
              {/* <CustomDrop /> */}
              <SettingsOutlinedIcon
                style={{ color: 'white', cursor: 'pointer' }}
                onClick={() => history.push(ROUTES.MASTERS)}
              />
            </div>
          )}
          <div className={classes.icon}>
            <HelpIcon style={{ color: 'white', cursor: 'pointer' }} />
          </div>
          <div className={classes.icon}>
            {/* <img src={Logo} width="44px" height="44px" alt="logo" /> */}
            <CustomAvatar />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}
